import _ from 'lodash';
import { SUCCESS, FAILURE } from './action-type';
import type { Action, AuthState } from '../types';

export const ACTION_TYPES = {
  LOGIN: 'authentication/LOGIN',
  GET_SESSION: 'authentication/GET_SESSION',
  LOGOUT: 'authentication/LOGOUT',
  CLEAR_AUTH: 'authentication/CLEAR_AUTH',
  ERROR_MESSAGE: 'authentication/ERROR_MESSAGE',
  CHANGE_ACTIVE_MEMBERSHIP: 'authentication/CHANGE_ACTIVE_MEMBERSHIP',
};

const initialState: AuthState = {
  isAuthenticated: false,
  loginSuccess: false,
  hasSessionExpired: false,
  loginError: false, // Errors returned from server side
  showModalLogin: false,
  sessionUser: {},
  errorMessage: null, // Errors returned from server side
  redirectMessage: null,
  sessionHasBeenFetched: false,
  idToken: null,
  logoutUrl: null,
  hasCheckedIfLoggedIn: false,
};

// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action: Action) => {
  if (
    state.isAuthenticated &&
    _.get(action, 'payload.response.status') === 401
  ) {
    return {
      isAuthenticated: false,
      hasSessionExpired: true,
    };
  }
  switch (action.type) {
    case FAILURE(ACTION_TYPES.CHANGE_ACTIVE_MEMBERSHIP):
    case FAILURE(ACTION_TYPES.LOGIN):
      return {
        ...initialState,
        errorMessage: _.get(
          action,
          'payload.response.data.message',
          'Unknown error',
        ),
        showModalLogin: true,
        loginError: true,
        hasCheckedIfLoggedIn: true,
      };
    case FAILURE(ACTION_TYPES.GET_SESSION):
      return {
        ...state,

        isAuthenticated: false,
        sessionHasBeenFetched: true,
        showModalLogin: true,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.CHANGE_ACTIVE_MEMBERSHIP):
    case SUCCESS(ACTION_TYPES.GET_SESSION):
    case SUCCESS(ACTION_TYPES.LOGIN): {
      const sessionUser = _.get(action, 'payload.data', {});

      return {
        ...state,

        loginError: false,
        showModalLogin: false,
        loginSuccess: true,
        isAuthenticated: true,
        hasCheckedIfLoggedIn: true,
        sessionUser,
      };
    }
    case ACTION_TYPES.LOGOUT:
      return {
        ...initialState,
        showModalLogin: true,
      };
    case ACTION_TYPES.ERROR_MESSAGE:
      return {
        ...initialState,
        showModalLogin: true,
        redirectMessage: action.payload.message,
      };
    case ACTION_TYPES.CLEAR_AUTH:
      return {
        ...state,

        showModalLogin: true,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default reducer;
